import React from 'react';

import { Pressable } from '@atlaskit/primitives/compiled/pressable';

export default function HtmlAttributes(): React.JSX.Element {
	return <Pressable type="submit">Submit form</Pressable>;
}
